import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './components/router';
import { useEffect } from 'react';
import './components/vyntezbuddy/vyntezbuddy.css';
import { AppToastProvider, useAppToast } from './components/vyntezbuddy/AppToastProvider';
import { initializeApiInterceptors, setApiErrorHandler } from './components/auth/interceptor';
import { LanguageProvider } from './components/vyntezbuddy/language';
import VyntezChatWidget from './components/vyntezbuddy/VyntezChatWidget';

const AppShell = () => {
  const toast = useAppToast();

  useEffect(() => {
    initializeApiInterceptors();
    setApiErrorHandler((message) => {
      toast.showError(message || 'Request failed. Please try again.');
    });
  }, [toast]);

  return (
    <>
      <RouterProvider router={router} />
      <VyntezChatWidget />
    </>
  );
};

const App = () => (
  <LanguageProvider>
    <AppToastProvider>
      <AppShell />
    </AppToastProvider>
  </LanguageProvider>
);

export default App;
